module.exports = __webpack_public_path__ + "static/bigpanel-bg-pc-23342e2811e1322024733615e06fe074.jpg";